var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeObjectives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 61.432,
    viewBox: "0 0 72 61.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "values",
    transform: "translate(-8.659 -49.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M115.087,262.2c-3.334,0-6.668.044-10-.015a4.771,4.771,0,0,0-3.791,1.519c-1.269,1.342-2.641,2.6-3.968,3.88-.8.782-1.711,1.092-2.6.221-.915-.9-.531-1.77.266-2.552,1.549-1.5,3.083-3.024,4.662-4.5a8.158,8.158,0,0,1,5.812-1.9c6.225-.015,12.465-.1,18.691.029a10.031,10.031,0,0,0,8.232-3.776q8.032-9.426,15.976-18.941a4.1,4.1,0,0,0,.9-1.372,1.916,1.916,0,0,0-.752-2.434c-.929-.561-1.49.148-2.051.708q-4.713,4.713-9.412,9.426c-.87.87-1.755,1.829-2.921.561-1-1.092-.251-1.991.575-2.832,3.157-3.127,6.27-6.284,9.426-9.412,2.346-2.331,4.765-2.552,6.83-.693a5.35,5.35,0,0,1,.384,7.494c-2.714,3.349-5.532,6.624-8.305,9.928-2.419,2.877-4.9,5.709-7.273,8.63-3.26,4.013-7.228,6.358-12.583,6.034C120.531,262.069,117.8,262.2,115.087,262.2Z",
    transform: "translate(-72.533 -158.112)",
    fill: "#fff",
    stroke: "#1a65ad",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M42.687,313.1H55.639c2.847,0,3.983,1.092,4.086,3.909a7.012,7.012,0,0,1-6.948,7.3c-4.809.044-9.633.015-14.442.015-.944,0-1.888-.044-2.272-1.136-.428-1.239.339-2.154,1.9-2.154,4.942-.015,9.869-.044,14.811.015a3.121,3.121,0,0,0,2.788-1.446,3,3,0,0,0,.708-2.759c-.413-1.106-1.519-.546-2.287-.546-7.287-.044-14.56-.015-21.847-.03-3.688-.015-6.978.811-9.825,3.408-3.142,2.862-6.55,5.414-9.825,8.128-.988.811-2.006,1.475-2.995.177-.915-1.224-.015-1.992.915-2.729q5.6-4.536,11.152-9.131A11.952,11.952,0,0,1,29,313.277c4.558-.089,9.131-.03,13.69-.03Z",
    transform: "translate(0 -229.914)",
    fill: "#fff",
    stroke: "#1a65ad",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M99.929,52.808c-1.545-.592-3.055-1.256-4.612-1.811a2.461,2.461,0,0,1-1.582-1.618c-.567-1.545-1.231-3.067-1.787-4.624A1.7,1.7,0,0,0,90.621,43.5,1.611,1.611,0,0,0,89.2,44.683c-.592,1.545-1.256,3.054-1.8,4.612a2.417,2.417,0,0,1-1.654,1.714c-1.618.543-3.175,1.219-4.757,1.847a1.385,1.385,0,0,0,.06,2.716c1.509.543,2.958,1.244,4.479,1.739a2.6,2.6,0,0,1,1.9,1.859c.5,1.57,1.159,3.091,1.775,4.624a1.494,1.494,0,0,0,1.3,1.1c.749.024,1.159-.483,1.413-1.147.616-1.642,1.268-3.26,1.871-4.9A2.147,2.147,0,0,1,95.2,57.432c1.594-.58,3.163-1.268,4.757-1.835.688-.241,1.207-.616,1.244-1.328C101.245,53.484,100.654,53.086,99.929,52.808ZM92.263,56.02a16.51,16.51,0,0,0-1.7,3.67A17.05,17.05,0,0,0,88.834,56c-.821-1.05-2.463-.978-3.936-1.968a5.993,5.993,0,0,0,5.65-5.324c.676,3.127,2.4,4.962,5.759,5.288C94.834,55.018,93.132,54.945,92.263,56.02Z",
    transform: "translate(-52.61 6.328)",
    fill: "#fff",
    stroke: "#1a65ad",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M259.513,165.691a10.05,10.05,0,0,1-4.7-4.636c-.893-1.859-2.052-1.847-2.982-.024a9.041,9.041,0,0,1-4.564,4.539,2.7,2.7,0,0,0-.64.4c-.881.688-.93,1.847.085,2.318a10.487,10.487,0,0,1,5.36,5.4,1.463,1.463,0,0,0,1.268.857,1.7,1.7,0,0,0,1.388-1.1,9.538,9.538,0,0,1,4.805-4.914C261.2,167.768,261.167,166.561,259.513,165.691Zm-6.133,5.034a6.145,6.145,0,0,0-3.743-3.622,5.464,5.464,0,0,0,3.67-3.477,5.53,5.53,0,0,0,3.574,3.429A6.016,6.016,0,0,0,253.379,170.726Z",
    transform: "translate(-198.624 -95.81)",
    fill: "#fff",
    stroke: "#1a65ad",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeObjectives);
export default __webpack_public_path__ + "static/media/icon-home-objectives.db884072f1515e7cff75a81eeeb10136.svg";
export { ForwardRef as ReactComponent };